import React from 'react';
import logo from '../assets/logo-transparent-no-part107.png';

export function NavBar({ activeSection, setActiveSection }) {
  const navItems = [
    { label: 'Home', section: 'home' },
    { label: 'Portfolio', section: 'portfolio' },
    { label: 'About Me', section: 'about' }
  ];

  return (
    <nav className="bg-slate-900 border-b border-slate-700 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo / Brand */}
          <div 
            onClick={() => setActiveSection('home')}
            className="flex items-center cursor-pointer"
          >
            <img
              src={logo}
              alt="Campbell's Flying Machines"
              className="h-14 w-auto"
            />
          </div>

          {/* Navigation Links */}
          <div className="flex items-center gap-8">
            {navItems.map((item) => (
              <button
                key={item.section}
                onClick={() => setActiveSection(item.section)}
                className={`text-sm font-medium transition-colors ${
                  activeSection === item.section
                    ? 'text-sky-400'
                    : 'text-slate-300 hover:text-white'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}